import { fontFamily } from "@/styles/font";
import React from "react";
import styled from "styled-components";

interface TagProps {
    label: string;
    isSelected: boolean;
    onClick: () => void;
}

const Tag: React.FC<TagProps> = ({ label, isSelected, onClick }) => {
    return (
        <TagButton type="button" onClick={onClick} $isSelected={isSelected}>
            {label}
        </TagButton>
    );
};

export default Tag;

const TagButton = styled.button<{ $isSelected: boolean }>`
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 6px 16px;
    min-height: 30px;
    background: ${(props) => (props.$isSelected ? "#007F73" : "#FFFFFF")};
    border: 1px solid ${(props) => (props.$isSelected ? "#007F73" : "#C0C0C0")};
    border-radius: 10px;
    cursor: pointer;
    white-space: nowrap;

    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: ${(props) => (props.$isSelected ? "#FFFFFF" : "#9D9D9D")};
    transition: all 0.2s ease-in-out;

    &:hover {
        background: ${(props) => (props.$isSelected ? "#006B62" : "#F5F5F5")};
        border-color: ${(props) => (props.$isSelected ? "#006B62" : "#C0C0C0")};
    }

    &:active {
        background: ${(props) => (props.$isSelected ? "#005C54" : "#EBEBEB")};
        border-color: ${(props) => (props.$isSelected ? "#005C54" : "#B3B3B3")};
    }
`;
